export default __webpack_public_path__ + "static/media/image6.b02bc694.png";